import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SuSupplierService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/su-suppliers', params);
    }

    store(body: any) {
        return super.post(`/su-suppliers`, body);
    }

    edit(supplierId: number) {
        return super.get(`/su-suppliers/${supplierId}/edit`);
    }

    update(supplierId: number, body: any) {
        return super.put(`/su-suppliers/${supplierId}`, body);
    }

    destroy(supplierId: number) {
        return super.delete(`/su-suppliers/${supplierId}`);
    }

    select(params: any = {}) {
        return super.get(`/su-suppliers/select`, params);
    }

    withOrders(params: any = {}): Observable<any> {
        return super.get(`/su-suppliers/with-orders`, params);
    }

    products(supplierId: string | number): Observable<any> {
        return super.get(`/su-suppliers/${supplierId}/products`);
    }

    updateProductSu(supplierId: string | number, productId: number, body: any): Observable<any> {
        return super.put(`/su-suppliers/${supplierId}/products/${productId}`, body);
    }
}
